export const pagingBtn = (currentPage, totalPages, url) => {
  const maxVisiblePages = 5; // 한 번에 표시할 최대 페이지 버튼 수
  const pagingList = document.getElementById("pagingList");

  // 기존 버튼을 초기화
  pagingList.innerHTML = "";

  // 페이지 번호의 시작과 끝 계산
  const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  // "이전" 버튼 추가
  if (currentPage > 1) {
    const prevLi = document.createElement("li");
    prevLi.classList.add("pagingBtn");
    prevLi.innerHTML = `<button class="pageBtn">이전</button>`;
    prevLi.addEventListener("click", () => pagingBtnEvent(url, currentPage - 1));
    pagingList.appendChild(prevLi);
  }

  // 페이지 번호 버튼 생성
  for (let i = startPage; i <= endPage; i++) {
    const li = document.createElement("li");
    li.classList.add("pagingBtn");
    li.innerHTML = `<button class="pageBtn ${currentPage === i ? "active" : ""}">${i}</button>`;
    li.addEventListener("click", () => pagingBtnEvent(url, i));
    pagingList.appendChild(li);
  }

  // "다음" 버튼 추가
  if (currentPage < totalPages) {
    const nextLi = document.createElement("li");
    nextLi.classList.add("pagingBtn");
    nextLi.innerHTML = `<button class="pageBtn">다음</button>`;
    nextLi.addEventListener("click", () => pagingBtnEvent(url, currentPage + 1));
    pagingList.appendChild(nextLi);
  }
};

export const pagingBtn2 = (page, next, url) => {
  const pageList = [page - 1, page, next ? page + 1 : null].filter(page => page > 0);
  const pagingList = document.getElementById("pagingList");

  pageList.forEach(value => {
    const li = document.createElement("li");
    li.classList.add("pagingBtn");
    li.innerHTML = `<button class="pageBtn ${page === value ? "active" : ""}">${value}</button>`;
    li.addEventListener("click", () => pagingBtnEvent(url, value));

    pagingList.appendChild(li);
  });
}

export const pagingBtnEvent = (url, page) => {
  window.location.href = `${url}&page=${page}`;
}

// 서브네비 설정
export const subNavEvent = (navGrp, navName) => {
  const navGrpBOx = document.querySelector(`.${navGrp}`);
  const navNameBox = document.querySelector(`.${navName}`);
  const subnavBox= document.querySelectorAll('.subNav');

  subnavBox.forEach(function(element) {
    element.classList.remove('active');
  });

  navGrpBOx.classList.add('active');
  if(navName !== "shop" ) {
    navNameBox.classList.add('active');
  }
}